// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app/utils/platform-adapter.ts"
);
import.meta.hot.lastModified = "1731877523871.602";
}
// REMIX HMR END

export const IS_CF_PAGES = typeof process === 'undefined';

// This hack is to prevent `node` modules/packages being bundled in the
// Cloudflare Pages context, which causes an error.
export async function safeRequireNodeDependency(module: string) {
  return import(module.split('').join(''));
}
